import { Play } from "lucide-react";
import { FILM_THUMBS } from "@/data/site";

export default function FilmsStrip() {
  return (
    <section className="py-24 md:py-32 bg-stone-900 text-stone-50 relative grain overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mb-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <p className="overline text-stone-500 mb-5">Real weddings · Real love</p>
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.05] tracking-tight text-stone-50">
              Cinematic films.
              <span className="italic text-stone-400"> Made for re-watching.</span>
            </h2>
          </div>
          <div className="md:col-span-6 flex items-end">
            <p className="text-stone-400 leading-relaxed">
              Six films from real Essex weddings. Every film is different, because every couple is.
              These aren't 90-minute boring edits. They're the 20–30 minutes you'll actually press play on.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-1">
          {FILM_THUMBS.map((f, i) => (
            <a
              key={f.id}
              href={`https://www.youtube.com/watch?v=${f.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="relative aspect-video overflow-hidden group block"
              data-testid={`film-${i}`}
            >
              <img
                src={f.thumb}
                alt={`Wedding film ${i + 1}`}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-stone-900/30 group-hover:bg-stone-900/10 transition-colors" />
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="w-14 h-14 rounded-full bg-white/95 flex items-center justify-center">
                  <Play className="w-5 h-5 fill-stone-900 text-stone-900 ml-0.5" />
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
